export const AUTHORIZATION_EXPORT_INITIAL_FORM = {
  fullName: "",
  address: "",
  identityNumber: "",
  signingPlace: "",
};

export const AUTHORIZATION_EXPORT_FIELDS = [
  {
    key: "fullName",
    label: "Tên người ủy quyền",
    placeholder: "Nhập tên người ủy quyền",
  },
  {
    key: "address",
    label: "Địa chỉ",
    placeholder: "Nhập địa chỉ",
  },
  {
    key: "identityNumber",
    label: "CCCD",
    placeholder: "Nhập số CCCD",
    inputMode: "numeric",
    pattern: "[0-9]*",
  },
  {
    key: "signingPlace",
    label: "Ký tại",
    placeholder: "Nhập nơi ký",
  },
];

const AUTHORIZATION_EXPORT_ERROR_MESSAGES = {
  address: "Vui lòng nhập địa chỉ.",
  fullName: "Vui lòng nhập tên người ủy quyền.",
  identityNumber: "Vui lòng nhập CCCD.",
  signingPlace: "Vui lòng nhập nơi ký.",
};

const trimValue = (value) => String(value ?? "").trim();

export const normalizeAuthorizationExportValue = (field, value) => {
  const nextValue = String(value ?? "");
  return field === "identityNumber" ? nextValue.replace(/\D/g, "") : nextValue;
};

export const buildAuthorizationExportErrors = (values = {}) =>
  Object.keys(AUTHORIZATION_EXPORT_INITIAL_FORM).reduce((errors, key) => {
    errors[key] = trimValue(values[key])
      ? ""
      : AUTHORIZATION_EXPORT_ERROR_MESSAGES[key];
    return errors;
  }, {});

export const buildAuthorizationExportData = (values = {}) =>
  Object.keys(AUTHORIZATION_EXPORT_INITIAL_FORM).reduce((payload, key) => {
    payload[key] = trimValue(normalizeAuthorizationExportValue(key, values[key]));
    return payload;
  }, {});

export const buildAuthorizationExportPayload = ({ templateUrl, values } = {}) => ({
  templateUrl: trimValue(templateUrl),
  data: buildAuthorizationExportData(values),
});

export const getTouchedAuthorizationExportFields = () =>
  Object.keys(AUTHORIZATION_EXPORT_INITIAL_FORM).reduce((touched, key) => {
    touched[key] = true;
    return touched;
  }, {});
